const jbevents = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          2.3522,
          48.8566
        ]
      },
      "properties": {
        "choose_your_escape": "🌆 City Energy",
        "category": "🚗", //drive
        "city": "Paris",
        "country": "France",
        "name": "Cruise by the Seine",
        "description": "Eiffel Tower views, cobbled streets, and café charm.",
        "name_description": null,
        "caption": "JB’s paws pad along Pont d’Iéna as the Eiffel sparkles over the Seine — Paris never sleeps, just like him.",
        "location": "Pont d'Iéna",
        "sub-category": "Scenic Stays",
        "type": ["allp", "fourpaws", "Scenic Stays"],
        "tags": ["fourpaws", "threep"],
        "best_time_to_go": null,
        "city_id": "par",
        "product_link": "https://jetlagboy.com/products/cruise-by-the-seine",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paris2.gif?v=1757823821",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_0262_2.jpg?v=1760923533",
        "source": null,
        "website": null,
        "lat": 48.8566,
        "lon": 2.3522
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -74.006,
          40.7128
        ]
      },
      "properties": {
        "choose_your_escape": "🌆 City Energy",
        "category": "🎾", //play
        "city": "New York City, NY",
        "country": "USA",
        "name": "Sunbathe Above the Skyline",
        "description": "Skyscrapers, rooftop pools, and endless energy.",
        "name_description": null,
        "caption": "High above the bustle, JB finds his own rooftop poolside escape in the city that never slows down.",
        "location": "Gansevoort Meatpacking NYC",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "threep", "Elevated Escapes"],
        "tags": ["fourpaws", "threep"],
        "best_time_to_go": null,
        "city_id": "nyc",
        "product_link": "https://jetlagboy.com/products/sunbathe-above-the-skyline",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/nyc25.gif?v=1758239800",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_9638.jpg?v=1760924479",
        "source": null,
        "website": null,
        "lat": 40.7128,
        "lon": -74.006
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -0.1278,
          51.5074
        ]
      },
      "properties": {
        "choose_your_escape": "🌆 City Energy",
        "category": "🚗", //drive
        "city": "London",
        "country": "UK",
        "name": "Cruise Past Big Ben",
        "description": "Big Ben, royal palaces, and double-decker adventures.",
        "name_description": null,
        "caption": "From red buses to ringing bells, JB cruises the Thames streets like a true Londoner on a mission.",
        "location": "Big Ben",
        "sub-category": "Scenic Stays",
        "type": ["allp", "fourpaws", "threep", "Scenic Stays"],
        "tags": ["fourpaws", "threep"],
        "best_time_to_go": null,
        "city_id": "lon",
        "product_link": "https://jetlagboy.com/products/cruise-past-big-ben",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/london.gif?v=1757826073",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_9637_2.jpg?v=1760925299",
        "source": null,
        "website": null,
        "lat": 51.5074,
        "lon": -0.1278
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          8.5417,
          47.3769
        ]
      },
      "properties": {
        "choose_your_escape": "🌆 City Energy",
        "category": "🥐", //eat
        "city": "Zurich",
        "country": "Switzerland",
        "name": "Lost in Medieval Routes",
        "description": "Mountains, chocolate, and old-town magic.",
        "name_description": null,
        "caption": "Chocolate, mountains, and a lakeside breeze — JB’s got Zurich wrapped around his paw.",
        "location": "Storchen",
        "sub-category": "Waterfront Retreats",
        "type": ["allp", "fourpaws", "threep", "Waterfront Retreats"],
        "tags": ["fourpaws", "threep"],
        "best_time_to_go": null,
        "city_id": "zur",
        "product_link": "https://jetlagboy.com/products/exploring-old-town",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/zurich2.gif?v=1757825185",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_7897.jpg?v=1760941216",
        "source": null,
        "website": null,
        "lat": 47.3769,
        "lon": 8.5417
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -122.4194,
          37.7749
        ]
      },
      "properties": {
        "choose_your_escape": "🌆 City Energy",
        "category": "🚗", //drive
        "city": "San Francisco, California",
        "country": "USA",
        "name": "Waymo Through Fog City",
        "description": "Golden Gate views, cable cars, and foggy hills.",
        "name_description": null,
        "caption": "Cable cars climb, sea lions cheer, and fog hugs the skyline — JB’s golden city adventure.",
        "location": "California St & Powell St",
        "sub-category": "Scenic Stays",
        "type": ["allp", "fourpaws", "threep", "Scenic Stays"],
        "tags": ["fourpaws", "threep"],
        "best_time_to_go": null,
        "city_id": "sfo",
        "product_link": "https://jetlagboy.com/products/waymo-through-fog-city",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/sf36.gif?v=1757821241",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_5699.jpg?v=1760938287",
        "source": null,
        "website": null,
        "lat": 37.7749,
        "lon": -122.4194
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          9.19,
          45.4642
        ]
      },
      "properties": {
        "choose_your_escape": "🌆 City Energy",
        "category": "🎾", //play
        "city": "Milan",
        "country": "Italy",
        "name": "Gaze at the Duomo",
        "description": "Duomo views, sleek design, and fashion streets.",
        "name_description": null,
        "caption": "Runways, piazzas, and cathedral spires — JB struts Milan with fashion in his stride.",
        "location": "Duomo di Milano",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "threep", "Elevated Escapes"],
        "tags": ["fourpaws", "threep"],
        "best_time_to_go": null,
        "city_id": "mil",
        "product_link": "https://jetlagboy.com/products/gaze-at-the-duomo",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/milan.gif?v=1757822904",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_2137.heic?v=1761002066",
        "source": null,
        "website": null,
        "lat": 45.4642,
        "lon": 9.19
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          12.3155,
          45.4408
        ]
      },
      "properties": {
        "choose_your_escape": "🌊 Waterfront Escapes",
        "category": "🛶", //explore
        "city": "Venice",
        "country": "Italy",
        "name": "Glide Through Back Canals",
        "description": "Gondolas, golden sunsets, and winding waterways.",
        "name_description": null,
        "caption": "Gondolas glide and lanterns glow — JB sails through Venice’s watery maze.",
        "location": "Aman Venice",
        "sub-category": "Sleep",
        "type": ["allp", "fourpaws", "onep", "Elevated Escapes"],
        "tags": ["fourpaws", "onep"],
        "best_time_to_go": null,
        "city_id": "ven",
        "product_link": "https://jetlagboy.com/products/glide-through-the-canals",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/venice2.gif?v=1757832888",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_6902.png?v=1761030188",
        "source": null,
        "website": null,
        "lat": 45.4408,
        "lon": 12.3155
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          9.2625,
          45.9773
        ]
      },
      "properties": {
        "choose_your_escape": "🌊 Waterfront Escapes",
        "category": "🎾", //play
        "city": "Bellagio, Lake Como",
        "country": "Italy",
        "name": "Stroll Through Bellagio",
        "description": "Villa gardens, sparkling waters, and mountain views.",
        "name_description": null,
        "caption": "Mountains mirror on the water while villa gardens bloom — JB chills Como-style.",
        "location": "Passalacqua",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "onep", "Elevated Escapes"],
        "tags": ["fourpaws", "onep"],
        "best_time_to_go": null,
        "city_id": "lcm",
        "product_link": "https://jetlagboy.com/products/stroll-through-bellagio",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/como2.gif?v=1757830818",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_9316.jpg?v=1761017095",
        "source": null,
        "website": null,
        "lat": 46.016,
        "lon": 9.2572
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          7.4276,
          43.7396
        ]
      },
      "properties": {
        "choose_your_escape": "🌊 Waterfront Escapes",
        "category": "🚗", //drive 
        "city": "Monte Carlo",
        "country": "Monaco",
        "name": "Cruise the Riviera",
        "description": "Seaside luxury, grand casinos, and glamorous lifestyle.",
        "name_description": null,
        "caption": "Palace steps, luxury wheels, and sea-kissed nights — JB strolls the Riviera in style.",
        "location": "Casino de Monte-Carlo",
        "sub-category": "Scenic Stays",
        "type": ["allp", "fourpaws", "onep", "Scenic Stays"],
        "tags": ["fourpaws", "onep"],
        "best_time_to_go": null,
        "city_id": "monaco",
        "product_link": "https://jetlagboy.com/products/cruise-the-riviera",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/monaco2.gif?v=1757835066",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_9681.jpg?v=1761020396",
        "source": null,
        "website": null,
        "lat": 43.7396,
        "lon": 7.4276
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          17.2184,
          40.9951
        ]
      },
      "properties": {
        "choose_your_escape": "🌊 Waterfront Escapes",
        "category": "⛵️", //play
        "city": "Puglia, Italy",
        "country": "Italy",
        "name": "Sail Into Polignano",
        "description": "Whitewashed walls, rocky shores, and Mediterranean charm.",
        "name_description": null,
        "caption": "White cliffs, turquoise tides, and candlelit caves — JB sniffs out Puglia’s seaside secrets.",
        "location": "Grotta Palazzese",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "onep", "Elevated Escapes"],
        "tags": ["fourpaws", "onep"],
        "best_time_to_go": null,
        "city_id": "pug",
        "product_link": "https://jetlagboy.com/products/sail-into-polignano",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/puglia.gif?v=1743753903",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_4562_2.heic?v=1761024375",
        "source": null,
        "website": null,
        "lat": 40.9951,
        "lon": 17.2184
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          9.2092,
          44.303
        ]
      },
      "properties": {
        "choose_your_escape": "🌊 Waterfront Escapes",
        "category": "⛵️", //play
        "city": "Portofino, Italy",
        "country": "Italy",
        "name": "Floating into Portofino",
        "description": "Colorful houses, sleek yachts, and coastal flair.",
        "name_description": null,
        "caption": "Pastel houses, glossy yachts, and coastal sparkle — JB’s harbor nights feel pure glam.",
        "location": "Splendido Mare, A Belmond Hotel, Portofino",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "onep", "Elevated Escapes"],
        "tags": ["fourpaws", "onep"],
        "best_time_to_go": null,
        "city_id": "portofino",
        "product_link": "https://jetlagboy.com/products/drift-into-portofino",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/portofino2.gif?v=1757836526",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_0712.jpg?v=1761005912",
        "source": null,
        "website": null,
        "lat": 44.303,
        "lon": 9.2092
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.4241,
          -33.9249
        ]
      },
      "properties": {
        "choose_your_escape": "🌊 Waterfront Escapes",
        "category": "🚁", //play
        "city": "Cape Town",
        "country": "South Africa",
        "name": "Soar Above Table Mountain",
        "description": "Table Mountain peaks, sandy beaches, and city buzz.",
        "name_description": null,
        "caption": "Where mountain meets ocean, JB finds his playground — Table Mountain above, penguins below.",
        "location": "Clifton 1st",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "onep", "Elevated Escapes"],
        "tags": ["fourpaws", "onep"],
        "best_time_to_go": null,
        "city_id": "cap",
        "product_link": "https://jetlagboy.com/products/soar-above-table-mountain",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capetown.gif?v=1743915545",
        "icon_url": null,
        "source": null,
        "website": null,
        "lat": -33.9249,
        "lon": 18.4241
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          9.838,
          46.497
        ]
      },
      "properties": {
        "choose_your_escape": "🏔 Mountain Magic",
        "category": "🚤", //play
        "city": "St. Moritz",
        "country": "Switzerland",
        "name": "Gliding Through St. Moritz",
        "description": "Ski slopes, shimmering lakes, and jet-set style.",
        "name_description": null,
        "caption": "Ski slopes sparkle, lakes shimmer — JB struts into St. Moritz like it’s a runway.",
        "location": "Badrutt's Palace Hotel St. Moritz",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "onem", "Elevated Escapes"],
        "tags": ["fourpaws", "onem"],
        "best_time_to_go": null,
        "city_id": "smo",
        "product_link": "https://jetlagboy.com/products/glide-through-st-moritz",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/stmoritz2.gif?v=1757830339",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_0310.png?v=1761006877",
        "source": null,
        "website": null,
        "lat": 46.497,
        "lon": 9.838
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          7.907,
          46.593
        ]
      },
      "properties": {
        "choose_your_escape": "🏔 Mountain Magic",
        "category": "🎾", //play
        "city": "Lauterbrunnen",
        "country": "Switzerland",
        "name": "Hike Lauterbrunnen Valley",
        "description": "Towering cliffs, wildflower meadows, and hidden chalets.",
        "name_description": null,
        "caption": "Cliffs pour silver streams — JB dashes through meadows in Switzerland’s fairytale valley.",
        "location": "Lauterbrunnen",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "onem", "Elevated Escapes"],
        "tags": ["fourpaws", "onem"],
        "best_time_to_go": null,
        "city_id": "laut",
        "product_link": "https://jetlagboy.com/products/hike-lauterbrunnen-valley",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/lauterbrunnen.gif?v=1757829216",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_0314.png?v=1761012902",
        "source": null,
        "website": null,
        "lat": 46.593,
        "lon": 7.907
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -71.208,
          46.8139
        ]
      },
      "properties": {
        "choose_your_escape": "🏔 Mountain Magic",
        "category": "🎿", //play
        "city": "Quebec City",
        "country": "Canada",
        "name": "Snow Tubing Runs",
        "description": "Cobblestone streets, snowy slopes, and castle views.",
        "name_description": null,
        "caption": "Cobblestone lanes and castle spires — JB finds magic in Old Quebec.",
        "location": "Fairmont Le Château Frontenac",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "onem", "Elevated Escapes"],
        "tags": ["fourpaws", "onem"],
        "best_time_to_go": null,
        "city_id": "qbc",
        "product_link": "https://jetlagboy.com/products/zoom-down-snow-tube-runs",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/quebecc.gif?v=1757829872",
        "icon_url": null,
        "source": null,
        "website": null,
        "lat": 46.8139,
        "lon": -71.208
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          11.787,
          43.095
        ]
      },
      "properties": {
        "choose_your_escape": "🌿 Countryside Charm",
        "category": "🎾", //play
        "city": "Pienza, Tuscany",
        "country": "Italy",
        "name": "Stroll Through Val d’Orcia",
        "description": "Rolling hills, winding roads, and golden fields.",
        "name_description": null,
        "caption": "Golden hills roll endlessly — JB trots between vineyards and olive groves under a Tuscan glow.",
        "location": "Val D’Orcia",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "twop", "Elevated Escapes"],
        "tags": ["fourpaws", "twop"],
        "best_time_to_go": null,
        "city_id": "tuscany",
        "product_link": "https://jetlagboy.com/products/stroll-through-val-d-orcia",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/tuscany.gif?v=1757829009",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_9678.png?v=1761013755",
        "source": null,
        "website": null,
        "lat": 43.095,
        "lon": 11.787
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          5.354,
          43.903
        ]
      },
      "properties": {
        "choose_your_escape": "🌿 Countryside Charm",
        "category": "🎾", //play
        "city": "Provence",
        "country": "France",
        "name": "Wander the Lavender Fields",
        "description": "Lavender fields stretching forever.",
        "name_description": null,
        "caption": "Purple fields hum with bees — JB bounds through Provence, a lavender daydream come true.",
        "location": "Lavanda",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "twop", "Elevated Escapes"],
        "tags": ["fourpaws", "twop"],
        "best_time_to_go": null,
        "city_id": "gargas",
        "product_link": "https://jetlagboy.com/products/wander-the-lavender-fields",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/provence.gif?v=1757829516",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_9685.png?v=1761024923",
        "source": null,
        "website": null,
        "lat": 43.903,
        "lon": 5.354
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          135.7681,
          35.0116
        ]
      },
      "properties": {
        "choose_your_escape": "🌿 Countryside Charm",
        "category": "🎾", //play
        "city": "Kyoto",
        "country": "Japan",
        "name": "Walk the Philosopher’s Path",
        "description": "Cherry blossoms in bloom.",
        "name_description": null,
        "caption": "Petals drift down quiet streets — JB wanders Kyoto’s cherry blossom wonderland",
        "location": "Haradani-en Garden",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "twop", "Elevated Escapes"],
        "tags": ["fourpaws", "twop"],
        "best_time_to_go": null,
        "city_id": "kyo",
        "product_link": "https://jetlagboy.com/products/walk-the-philosopher-s-path",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/kyoto.gif?v=1757832505",
        "icon_url": null,
        "source": null,
        "website": null,
        "lat": 35.0116,
        "lon": 135.7681
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -111.6111,
          37.0275
        ]
      },
      "properties": {
        "choose_your_escape": "🌵 Desert Dreams",
        "category": "🚗", //drive
        "city": "Canyon Point, Utah",
        "country": "USA",
        "name": "Canyon Dreams at Amangiri",
        "description": "Red rocks, wide skies, and desert roads.",
        "name_description": null,
        "caption": "Red rocks and wide skies — JB rides the desert wind through canyons of silence.",
        "location": "Amangiri",
        "sub-category": "Scenic Stays",
        "type": ["allp", "fourpaws", "oned", "Scenic Stays"],
        "tags": ["fourpaws", "oned"],
        "best_time_to_go": null,
        "city_id": "cnt",
        "product_link": "https://jetlagboy.com/products/rolling-through-the-canyon",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/utah.gif?v=1743754926",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/IMG_3982.jpg?v=1761030885",
        "source": null,
        "website": null,
        "lat": 37.0097,
        "lon": -111.6955
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          35.4444,
           30.3285
        ]
      },
      "properties": {
        "choose_your_escape": "🌵 Desert Dreams",
        "category": "🎾", //play
        "city": "Petra",
        "country": "Jordan",
        "name": "Wander Through Candlelit Desert",
        "description": "Rock-carved temples, candlelit paths, and ancient magic.",
        "name_description": null,
        "caption": "Carved in rose stone, Petra glows at dusk — JB’s paws echo through ancient paths.",
        "location": "Wadi Musa",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "oned", "Elevated Escapes"],
        "tags": ["fourpaws", "oned"],
        "best_time_to_go": null,
        "city_id": "pet",
        "product_link": "https://jetlagboy.com/products/wander-through-candlelit-desert",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/petra.gif?v=1757821530",
        "icon_url": null,
        "source": null,
        "website": null,
        "lat": 30.3285,
        "lon": 35.4444
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.296249,
          25.276987
        ]
      },
      "properties": {
        "choose_your_escape": "🌵 Desert Dreams",
        "category": "🌵", //play
        "city": "Dubai",
        "country": "UAE",
        "name": "Ride the Desert Dunes",
        "description": "Skyline towers, sandy dunes, and camel trails.",
        "name_description": null,
        "caption": "Skyscrapers rise from sand and camels stride dunes — JB discovers Dubai’s golden oasis.",
        "location": "Desert Safari Visit",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "fourpaws", "oned", "Elevated Escapes"],
        "tags": ["fourpaws", "oned"],
        "best_time_to_go": null,
        "city_id": "dxb",
        "product_link": "https://jetlagboy.com/products/ride-the-desert-dunes",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/dubai2.gif?v=1757834561",
        "icon_url": null,
        "source": null,
        "website": null,
        "lat": 25.2048,
        "lon": 55.2708
      }
    },
    
        {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          45.414726, 6.655549
        ]
      },
      "properties": {
        "choose_your_escape": "🏔 Mountain Magic",
        "category": "🌵", //play
        "city": "Courchevel",
        "country": "France",
        "name": "Après-Ski in Courchevel",
        "description": "Alpine peaks, sun-soaked slopes, and clinking glasses.",
        "name_description": null,
        "caption": "Skiers carve down Courchevel's powdered runs while laughter rises from wooden tables below — the mountains witness it all, silent and eternal.",
        "location": "Ultima Hotel Courchevel",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "onem", "Elevated Escapes"],
        "tags": ["fourpaws", "onem"],
        "best_time_to_go": null,
        "city_id": "cou",
        "product_link": "https://jetlagboy.com/products/apres-ski-in-courchevel",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/dubai2.gif?v=1757834561",
        "icon_url": null,
        "source": null,
        "website": null,
        "lat": 6.655549,
        "lon": 45.414726
      }
    },
    
            {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          6.63643,45.41538
        ]
      },
      "properties": {
        "choose_your_escape": "🏔 Mountain Magic",
        "category": "🌵", //play
        "city": "Courchevel",
        "country": "France",
        "name": "Après-Ski in Courchevel",
        "description": "Alpine peaks, sun-soaked slopes, and clinking glasses.",
        "name_description": null,
        "caption": "Skiers carve down Courchevel's powdered runs while laughter rises from wooden tables below — the mountains witness it all, silent and eternal.",
        "location": "Ultima Hotel Courchevel",
        "sub-category": "Elevated Escapes",
        "type": ["allp", "onem", "Elevated Escapes"],
        "tags": ["fourpaws", "onem"],
        "best_time_to_go": null,
        "city_id": "cou",
        "product_link": "https://jetlagboy.com/products/apres-ski-in-courchevel",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/courchevelgif.gif?v=1757801150",
        "icon_url": null,
        "source": null,
        "website": null,
        "lat": 6.63643, 
        "lon": 45.41538
      }
    },

  ]
}